import { GdprStorageType } from "UidispatcherApiModule";
const { GdprStorage }: { GdprStorage: GdprStorageType } =
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    await import("uidispatcher_api/UidispatcherApiModule");
export { GdprStorage };
